import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from 'constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'Emilus';
export const API_BASE_URL = env.API_ENDPOINT_URL
export const APP_PREFIX_PATH = '/app';
export const AUTH_PREFIX_PATH = '/auth';
export const REDIRECT_URL_KEY = 'redirect'
export const AUTHENTICATED_ENTRY = `${APP_PREFIX_PATH}/dashboards/default`;
export const UNAUTHENTICATED_ENTRY = '/login'

export const SUPPORTED_LOCALES = ['en', 'es'];
export const DEFAULT_LOCALE = 'es';
export const LOCALE_STORAGE_KEY = 'app:locale';

export const resolveInitialLocale = () => {
	if (typeof window === 'undefined') return DEFAULT_LOCALE;
	try {
		const stored = window.localStorage.getItem(LOCALE_STORAGE_KEY);
		if (stored && SUPPORTED_LOCALES.includes(stored)) return stored;
	} catch (_) { /* localStorage unavailable */ }
	const navLang = (window.navigator.language || '').slice(0, 2).toLowerCase();
	if (SUPPORTED_LOCALES.includes(navLang)) return navLang;
	return DEFAULT_LOCALE;
};

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: resolveInitialLocale(),
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	blankLayout: false
};
